// Mutation hook - modyfikacja transakcji
// PUT /api/ui/sales-crm/deals/{id}

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IPutDealRequest } from 'api/types/deals';

interface IPutDealResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

interface IPutDealVariables {
  id: number;
  body: IPutDealRequest;
}

const putDeal = ({ id, body }: IPutDealVariables): Promise<IPutDealResponse> =>
  axios.put(`/sales-crm/deals/${id}`, body);

export const usePutDeal = (
  options?: UseMutationOptions<IPutDealResponse, IError, IPutDealVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IPutDealResponse, IError, IPutDealVariables>(putDeal, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(['sales-crm-deals-kanban']);
      await queryClient.invalidateQueries(['sales-crm-deals']);
      await queryClient.invalidateQueries(['sales-crm-deal', variables.id]);
      await queryClient.refetchQueries(['sales-crm-deal', variables.id]);
      options?.onSuccess?.(data, variables, context);
    },
  });
};
